import { FormattedMessage } from '@flipster/i18n';
import { QuoteCurrencyListExceptUsdt } from '@flipster/utils/constants/currency';
import { mapToObj } from '@flipster/utils/map-to-obj';

import type { CarouselInfo } from './types';

export type MarketCarouselType =
  | 'yourOpenPositions'
  | 'yourHoldings'
  | 'hotTradings'
  | 'newListings'
  | 'priceChange24h'
  | 'volume'
  | 'absFundingRates'
  | 'yourFrequentTrades'
  | (typeof QuoteCurrencyListExceptUsdt)[number];

const quoteCurrencyCarouselMapper: Record<(typeof QuoteCurrencyListExceptUsdt)[number], CarouselInfo> = mapToObj(
  QuoteCurrencyListExceptUsdt,
  (currency) => ({
    title: <FormattedMessage id='Market.r251015.Symbol_pairs' values={{ symbol: currency }} />,
    seeAll: true,
    category: currency,
  }),
);

export const CarouselMapper: Record<MarketCarouselType, CarouselInfo> = {
  yourOpenPositions: {
    title: <FormattedMessage id='Market.r250919.Your_open_positions' />,
    seeAll: false,
  },
  yourHoldings: {
    title: <FormattedMessage id='Assets.r250401.Your_holdings' />,
    seeAll: false,
  },
  hotTradings: {
    title: <FormattedMessage id='Market.r250919.Hot_trading_pairs' />,
    seeAll: true,
    category: 'hotTradings',
  },
  newListings: {
    title: <FormattedMessage id='Market.r250919.New_listings' />,
    seeAll: true,
    category: 'newListings',
  },
  priceChange24h: {
    title: <FormattedMessage id='Market.r250919.Top_movers' />,
    seeAll: true,
    category: 'priceChange24h',
  },
  volume: {
    title: <FormattedMessage id='Market.r250919.High_volume' />,
    sub: <FormattedMessage id='Common.r250919.Hour_h_bracket' values={{ hour: 24 }} />,
    seeAll: true,
    category: 'volume',
    alertProps: {
      title: <FormattedMessage id='Market.r250919.High_volume' />,
      message: <FormattedMessage id='Market.r250925.High_volume_info' />,
      confirmText: <FormattedMessage id='Common.r250401.Ok' />,
    },
  },
  absFundingRates: {
    title: <FormattedMessage id='Market.r250919.High_funding_rates' />,
    seeAll: true,
    category: 'absFundingRates',
    alertProps: {
      title: <FormattedMessage id='Market.r250919.High_funding_rates' />,
      message: <FormattedMessage id='Market.r250925.High_funding_rates_info' />,
      confirmText: <FormattedMessage id='Common.r250401.Ok' />,
    },
  },
  yourFrequentTrades: {
    title: <FormattedMessage id='Market.r250919.Your_frequent_trades' />,
    seeAll: true,
    category: 'yourFrequentTrades',
  },
  ...quoteCurrencyCarouselMapper,
};
